import React, { useState, useEffect, useImperativeHandle, useMemo, useCallback, ReactNode, useRef, forwardRef, useContext } from "react";
import classnames from 'classnames';
import { useUser } from "@/contexts/UserContext";
import { getAllProducts } from "@/services/product.service";
import { useTenantApi } from "@/hooks/useTenantApi";

type UseReportsParameters = {
    onlySubscribed?: boolean;
}

export const useReports = ({
    onlySubscribed = true,
}: UseReportsParameters) => {
    const {subscribedSkus, company, user} = useUser();
    // const {deleteUserFavorite, createUserFavorite, getUserFavorite} = useTenantApi();

    const allProducts = getAllProducts();

    const finalReports: (ProductWithMeta & {
        reportType: string | undefined;
        sectionHeader: string | undefined;
    })[] = useMemo(() => {
        const reports = allProducts
            .filter(({ type }) => type === 'report')
            .map(report => {
                const reportOptions = report?.metadata?.reportOptions;
                return {
                    ...report,
                    reportType: reportOptions?.reportType,
                    sectionHeader: reportOptions?.sectionHeader
                }
            }) 
            .toSorted((a, b) => a.title.localeCompare(b.title, 'en', {sensitivity: 'base'}))

        if (onlySubscribed) {
            if (!company?.accessLevel) {
                throw Error('missing_company_access_level');
                // return reports.filter(({ sku }) => subscribedSkus.includes(sku));
            }

            return reports.filter(({ accessLevels, sku }) => accessLevels.includes(company?.accessLevel) && subscribedSkus.includes(sku));
        }

        return reports;
    }, [allProducts, subscribedSkus, onlySubscribed]);


    return finalReports;
};

export default useReports;

useReports.displayName = 'useReports';




// export function getAllStories() {
//     return getAllProducts().filter(({type, metadata, subscriptionLevel}) => {
//         return type === 'story' && Number.isFinite(subscriptionLevel);
//     });
// }



// export function getAllSimulators() {
//     return getAllProducts()
//         .filter(({ type, metadata, subscriptionLevel }) => {
//             return type === 'simulator' // && metadata?.reportOptions?.sectionHeader && Number.isFinite(subscriptionLevel);
//         })
// }




// export function getAllAlerts(): ProductWithMeta[] {
//     return getAllProducts()
//         .filter(({ type, metadata, subscriptionLevel }) => {
//             return type === 'alert' && Number.isFinite(subscriptionLevel);
//         })
//         .map((alert) => ({
//             ...alert,
//             alertType: alert?.metadata?.alertOptions?.alertType,
//         }));
// }



// export function getAllProducts(): ProductWithMeta[] {
//     return allProducts.filter(({ accessLevels }) => accessLevels.includes(accessLevel));
// }

// export function getAllReports(products?: ProductWithMeta[]): ProductWithMeta[] {
//     return (products ?? getAllProducts())
//         .filter(({ type, metadata, subscriptionLevel }) => {
//             return type === 'report' // && metadata?.reportOptions?.sectionHeader && Number.isFinite(subscriptionLevel);
//         })
//         .map((report) => ({
//             ...report,
//             reportType: report?.metadata?.reportOptions?.reportType,
//             sectionHeader: report?.metadata?.reportOptions?.sectionHeader
//         }));
// }


// as (Omit<ProductWithMeta, 'type'> & {
//     reportType: string;
//     sectionHeader: string;
//     type: 'report';
// })[];